<template>
  <v-autocomplete
    outlined
    dense
    :items="parts"
    v-model="localPart"
    :item-text="v => v.ratio ? `${v.name} (${v.ratio}%) - ${v.formattedPrice}` : v.name"
    item-value="id"
    :disabled="disabled"
    return-object
    @input="v => $emit('input', v)"
    @change="validationModel && validationModel.$touch()"
    :label="$t(partTranslationKey + '.select')"
    :error-messages="errorMessages"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
      <v-list-item-title>{{ item.ratio ? `${item.name} (${item.ratio}%)` : item.name }}</v-list-item-title>
      <v-list-item-subtitle>{{ $t('guarantees.partSubtitle', item) }}</v-list-item-subtitle>
      </v-list-item-content>
   </template>
  </v-autocomplete>
</template>

<script>
import { getLocalizationContext } from '../../helpers/translations'

export default {
  name: 'GuaranteesPartsSelect',
  props: {
    value: [Object, Array],
    parts: Array,
    disabled: Boolean,
    multiple: Boolean,
    errorMessages: Array,
    validationModel: Object,
    isMultiCurrency: Boolean
  },
  data () {
    return {
      localPart: this.multiple ? [...(this.value || [])] : { ...(this.value || {}) }
    }
  },
  computed: {
    allSelected () {
      return this.parts.length === this.value.length
    },
    partTranslationKey () {
      return getLocalizationContext(this.isMultiCurrency)
    }
  },
  watch: {
    value (v) {
      this.localPart = this.multiple ? [...v] : { ...v }
    }
  }
}
</script>
